module.exports = {"id":"232411","name":"Christopher Nkunku","rating":"73","photo":"./data/images/photos/2/232411.png","club":{"name":"Paris","logo":"./data/images/clubs/Paris.png"},"positions":["MC","AG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristopherNkunku0.json
// module id = 814
// module chunks = 0